export default __webpack_public_path__ + "static/media/hexagons-no-3.cee93fa0.ogg";